// Shared view helpers for Project Build and Project Details pages
// Keep UI logic centralized to avoid duplication

import { CORE_ISSUES, SCALE_OPTIONS, issueIcons, ISSUE_STATUSES, issueStatusIcons } from '../constants/index.js';
import { SOLUTION_TYPE_STYLES } from '../../../../constants/solutionTypes.js';

export const getScaleLabel = (id) => SCALE_OPTIONS.find(s => s.id === id)?.label || id;

export const getIssueLabel = (issue) => {
  if (typeof issue === 'object' && issue !== null) return issue.name || issue.label || issue.id || '';
  return issue || '';
};

export const getIssueId = (issue) => {
  if (!issue) return '';
  if (typeof issue === 'object' && issue !== null) return issue.id || '';
  const byName = CORE_ISSUES.find(i => i.name.toLowerCase() === String(issue).toLowerCase());
  if (byName) return byName.id;
  return String(issue).toLowerCase().trim().replace(/\s+/g, '_');
};

export const getIssueIcon = (issue) => issueIcons[getIssueId(issue)] || null;

export const getIssueStatus = (id) => ISSUE_STATUSES.find(s => s.id === id);
export const getIssueStatusIcon = (id) => issueStatusIcons[id] || null;

// -------- Solution Type Helpers --------
export const getSolutionTypeValue = (projectLike) => {
  if (!projectLike) return '';
  const s = projectLike.solutionType || projectLike.solution_type || projectLike.solution?.type || projectLike.type || '';
  return typeof s === 'string' ? s : '';
};

const prettify = (s) => String(s || '')
  .replace(/[_-]+/g, ' ')
  .replace(/\b\w/g, (c) => c.toUpperCase());

export const getSolutionTypeMeta = (value) => {
  const st = SOLUTION_TYPE_STYLES[value];
  const label = st?.label || prettify(value);
  const icon = st?.icon || null;
  const styles = st ? {
    background: st.bgColor,
    color: st.color,
    borderColor: st.borderColor,
  } : {
    background: '#f7f7f8',
    color: '#374151',
    borderColor: '#e5e7eb',
  };
  return { label, icon, styles };
};
